import React, { useState, useEffect } from 'react'
import ForumServices from '../../../services/forumServices'
import Loader from 'react-loader-spinner'
import { siteUrl } from '../../../shared/utils/siteUrl'

import './commentsSection.scss'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

const CommentsSection = ({
  profilePhoto,
  author,
  comment,
  likesComment,
  date,
  idComment,
  isMobile,
  config,
  zonaVirtualInter
}) => {
  const [isLiked, setIsLiked] = useState(false)
  const [loadingLike, setLoadingLike] = useState(true)

  const [likes, setLikes] = useState(likesComment)

  const handleLike = commentId => {
    // pregunta si esta logueado
    if (localStorage.getItem('TOKEN_INFO') === null) {
      sessionStorage.setItem(
        'NEXT_PAGE',
        window.location.pathname + '#zona-virtual'
      )
      window.location.href = siteUrl + '/login/'
    } else {
      // const config = getConfig()
      try {
        setLoadingLike(true)
        ForumServices.saveLikeByCommentId(commentId, !isLiked, config).then(
          resp => {
            console.log('likes---->', resp)
            setIsLiked(!isLiked)
            setLoadingLike(false)
            // para cambiar el texto de cuantos likes tiene
            isLiked ? setLikes(likes - 1) : setLikes(likes + 1)
          }
        )
      } catch (error) {
        console.log(error)
        setIsLiked(!isLiked)
      }
      // test()
    }
  }

  useEffect(() => {
    // const config = getConfig()
    // si esta logueado realiza la consulta del servicio para saber si le dio like el usuario logueado
    if (localStorage.getItem('TOKEN_INFO') === null) {
      setIsLiked(false)
      setLoadingLike(false)
    } else {
      try {
        ForumServices.getLikeByCommentId(idComment, config).then(resp => {
          setIsLiked(resp.data)
          setLoadingLike(false)
        })
      } catch (error) {
        console.log(error)
      }
    }
  }, [])

  return (
    <div
      className={
        'f-commentsSection ' + (zonaVirtualInter && 'zonaVirtualInter')
      }
    >
      {!isMobile && <img src={profilePhoto} alt="foto de perfil usuaria" />}
      <div className="f-commentsSection__commentUser">
        <section className="f-commentsSection__commentUser__headerUser">
          {/* En Mobile cambio la estructura del header por eso se hace esto: */}
          {isMobile ? (
            <>
              <figure className="f-infoUserMobile">
                <img src={profilePhoto} alt="foto de perfil usuaria" />
                <span className="f-infoUserMobile__span">
                  <h5>{author}</h5>
                  <p>{date}</p>
                </span>
              </figure>
            </>
          ) : (
            <h5>{author}</h5>
          )}
          <div className="f-commentsSection__commentUser__headerUser__likes">
            {!isMobile && <p>{date}</p>}
            <p>{likes}</p>

            {loadingLike ? (
              <Loader type="TailSpin" color="#ffffff" height={20} width={20} />
            ) : (
              <span
                className={
                  'f-icon heart ' +
                  (isLiked ? 'icon2-corazon-relleno1 small' : 'icon-heart-1')
                }
                onClick={() => {
                  handleLike(idComment)
                  pushEventDataLayer('Interacciones - historias','Cur-v','Click','Like','Likes',likes)
                }}
              />
            )}
          </div>
        </section>
        <p>{comment}</p>
      </div>
    </div>
  )
}

export default CommentsSection
